import React, {useState, useEffect , useRef} from "react";
import { Link } from "react-router-dom";

import LeftMenuLayout from 'layouts/LeftMenuLayout';

import classNames from 'classnames';
import * as Yup from 'yup';
import {API_ENDPOINT, toast_anim } from 'components/config/Common'
import {Loading , WalletPointsIcon} from "components/custom-icons";

import axios from 'axios';  
import {APP_URL, APP_NAME , IMG_URL , LIMIT , amount_format} from 'components/config/Common'

import Helmet from 'react-helmet'
import { ReactSEOMetaTags } from 'react-seo-meta-tags'
import { toast } from 'react-toastify';
import ScrollPageTop from 'components/ui/ScrollPageTop'
import {Links} from 'routes/PathLink'
import Seo from 'components/seo/seo'

import { Pagination, Select } from "antd";
import { Table } from "components/ui/table";
import {
  useForumQuery,
} from 'data/dashboard-data';

const MyForums = () => {
	
	const [access_token, setAccess_token] = useState(localStorage.getItem('access_token'))
	
	//const [forums,setForums]= useState([]);
	
  const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(process.env.REACT_APP_PAGE_LIMIT);
    const [orderBy, setOrder] = useState('created_at');
    const [sortedBy, setColumn] = useState('desc');

const onPagination = (current) => {
    console.log("current Page",current);
    setPage(current);
  }

  const onPageSize = (value) => {
    setPageSize(value);
    setPage(1);
  }
	

  const {
      forums,      
      paginatorInfo,
      isLoading,
      error,
    } = useForumQuery({       
      limit: pageSize,
      page,    
      orderBy,
      sortedBy,
    });
	

	const siteMetadata = {
		url: `${APP_URL}/profile`,
		title:  `My wallet - ${APP_NAME}`,
		description: `My wallet - ${APP_NAME}`,
	}



    
    const skeleton = Array.from({ length: pageSize }, (_, i) => ({
        id: `sk-${i}`,
        _isSkeleton: true
        }));
    
        const columns = [
            {
              title: 'Sr.No.',
              dataIndex: 'srno',
              key: 'id',
              align: 'left',
              width: 50,
              render: (text, record, index) => {
                return index+1
            },
            },
            {
              title: 'Company Name',
              dataIndex: 'name',
              key: 'name',
              align: 'left',
              width: 200,
              render:(name,record) =>{
                  let path = `${record.id}`;
                  
    
                 return (<div
                  className="overflow-hidden truncate whitespace-nowrap text-wrap" >
                   {record?.company?.name ?
                    (<Link className="text-accent" target="_blank" to={`${process.env.REACT_APP_URL}${Links.COMPANY}/${record?.company?.symbol}`}><span className="text-sm">{record?.company?.name}</span></Link>)
                    :(null)
                  }          
                </div>)
                }
            },
            
            {
              title: 'Forum Posts',
              dataIndex: 'content',
              key: 'content',
              align: 'left',
              width: 200,
              render:(name,record) =>(
                <>{<div>{record?.content}</div>}</>
              )
            },
            {
              title: 'Likes',
              dataIndex: 'likes_count',
              key: 'likes_count',
              align: 'left',
              width: 50,
              render:(name,record) =>(
                <>{<div>{record?.likes_count}</div>}</>
              )
            },
            {
              title: 'Replies',
              dataIndex: 'replies_count',
              key: 'replies_count',
              align: 'left',
              width: 50,
              render:(name,record) =>(
                <>{<div>{record?.replies_count}</div>}</>
              )
            },
            
            
          
        ];


	return (
		<ScrollPageTop>
        <Seo 
            title={`My Forums - ${APP_NAME}`}
            desc={`My Forums - ${APP_NAME}`}
            url={`${APP_URL}/my-forums`}
          />
         <LeftMenuLayout> 
				<div className="w-full ">
					<div className={classNames('bg-white w-full shadow rounded mb-8')}>
						{/*<p className="text-lg lg:text-xl text-heading capitalize mb-5 dark:text-zinc-400">Welcome You are logged In.</p>*/}
						
						<h2 className="text-2xl font-semibold p-8">My Forums</h2>

						<Table            
                columns={columns}
                rowKey="id"
                data={isLoading ? skeleton : forums}
                scroll={{ x: 900 }}
                
                rowClassName={(record, index) => {
                    if (record._isSkeleton) {
                        // Animate only alternate skeleton rows (even rows)
                        return index % 2 === 0
                        ? "skeleton-row pulse-row"
                        : "skeleton-row-odd";
                    }

                    if (record._isHeader) return "repeat-header";

                    return "";
                }}
            />
            <div className="w-full flex justify-start mb-5 p-5">
                {!!paginatorInfo?.total && ( 
                <div className="w-full flex items-left justify-between flex-wrap">
                    <div>
                    <Pagination
                    total={paginatorInfo.total}
                    current={paginatorInfo.currentPage}
                    pageSize={paginatorInfo.perPage}
                    onChange={onPagination}
                    showSizeChanger={false}
                    className="flex-wrap"
                    />
                    </div>
                    <div className="flex items-center justify-center">
                        <div className="px-5 text-sm text-gray-500">Results Per Page</div>
                        <Select
                            value={pageSize}
                            onChange={onPageSize}
                            options={[
                                { value: 10, label: "10 rows" },
                                { value: 25, label: "25 rows" },
                                { value: 50, label: "50 rows" },
                                { value: 100, label: "100 rows" },
                                
                            ]}
                            style={{ width: 130 }}
                        />
                    </div>
                </div>
                )} 
            </div>
					</div>
				</div>
		</LeftMenuLayout> 
      </ScrollPageTop>
   );
};

export default MyForums;